import { RichText } from '@/webapp/src/components/other/RichText/index.js'
import { useMemo } from 'react'
import showdown from 'showdown'

const converter = new showdown.Converter()

export const MDDoc = ({ md }: { md: string }) => {
  const html = useMemo(() => converter.makeHtml(md), [md])
  return <RichText html={html} />
}
